import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { PathologyModel } from '../models/PathologyModel';
import { URLsConfig } from '../URLsConfig';
@Injectable()
export class PathologyService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }

  public getPathologyCLookupTop(compCode: string) {
      let params = new HttpParams();
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<PathologyModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Pathology/ClassificationCLookupTop', options);
  }
}
